import {combineReducers} from 'redux';
import {coupons, isGetLimits, isLoadingCoupons} from "./reducers/couponReducer";
import {
    playerHasAccounts,
    playerIdentified,
    playerIdentifiedLoaded,
    playerAuthenticated,
    playerInfo,
    playerIsFound,
    playerRequestCompleted,
    playerToken,
    sportAndChlInResults,
    playerAccountsLoaded,
    playerAuthenticatedLoaded
} from './reducers/playerInfoReducer';
import {steps, stepsLoaded} from "./reducers/stepsReducer";
import {sports} from "./reducers/sportsReducer";
import {categories} from './reducers/categoriesReducer';
import {displayedFixture} from "./reducers/oneFixtureReducer";
import {isLoadingSettings, playerSettings} from "./reducers/playerSetttingsReducer";
import { SpirsType, TreesType } from './types';
import {favoritesCount} from "./reducers/fixturesReducer";
import {showWidget, widgetId as widget} from "./reducers/widgetIdReducer";
import {debugMode} from "./reducers/debugReducer";
import {fingerprint} from "./reducers/fingerprintReducer";
import { emptyTree, favorites, line, live, rating, result } from './reducers/treeReducer';
import {selectedSportMenu} from "./reducers/sportMenuReducer";
import {search} from "./reducers/searchReducer";
import {timePeriodReducer} from './reducers/timePeriodReducer';
import { categoriesIDReducer } from './reducers/categoriesIDReducer';
import { tournamentsIDReducer } from './reducers/tournamentsIDReducer';
import { rightPanelTab } from './reducers/rightPanelReducer';

export const Reducer = combineReducers<SpirsType>({
    displayedFixture,
    sports,
    steps,
    stepsLoaded,
    playerInfo,
    playerIsFound,
    playerRequestCompleted,
    playerSettings,
    coupons,
    rightPanelTab,
    isLoadingCoupons,
    isLoadingSettings,
    widget,
    showWidget,
    debugMode,
    playerToken,
    playerIdentified,
    playerIdentifiedLoaded,
    playerHasAccounts,
    playerAccountsLoaded,
    playerAuthenticated,
    playerAuthenticatedLoaded,
    sportAndChlInResults,
    fingerprint,
    favorites,
    favoritesCount,
    result,
    isGetLimits,
    selectedSportMenu,
    search,
    timePeriodReducer,
    categories,
    categoriesIDReducer,
    tournamentsIDReducer,
    trees: combineReducers<TreesType>({
        LIVE: live,
        PREMATCH: line,
        RATING_PREMATCH: rating,
        NONE: emptyTree
    })
});
